import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";


const UserLayouts = () => {
  return (
    <>
      <Navbar/>
      <main style={{ padding: "20px" }}>
        <Outlet />
      </main>
    </>
  );
};

export default UserLayouts;
